import { render, staticRenderFns } from "./seize.vue?vue&type=template&id=b4913a52&scoped=true&"
var script = {}
import style0 from "./seize.vue?vue&type=style&index=0&id=b4913a52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4913a52",
  null
  
)

export default component.exports